<!--
 * @Author: hcw
 * @Date: 2022-08-24 15
-->
<template>
    <!-- <div class="base-son-title">
        <div class="txt-1">{{ title }}</div>
        <div class="txt-2">{{ sonTitle }}</div>
        <div class="dashed"></div>
    </div> -->
    <div class="base-son-title">
        <div class="base-son-title-txt">
            <div class="line"></div>
            <p class="txt-1" :class="status ? 'txt-1-1' : ''">{{enTitle}}</p>
            <div class="base-son-title-txt1">
                <p class="txt-2">{{ title }}</p>
                <img src="@/assets/xia.png" alt="">
                <p class="txt-3" :class="status ? 'txt-1-1' : ''">{{ title1 }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BaseSonTitle",
    props: {
        enTitle:{
            type: String,
            default: "标题"
        },
        title: {
            type: String,
            default: "标题"
        },
        title1: {
            type: String,
            default: "标题"
        },
        status: {
          type: Boolean,
          default: false
        }
    }
}
</script>
<style lang="scss" scoped>
.base-son-title {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .base-son-title-txt{
        .line{
          background-color: rgb(250, 204, 10);
          width: 90px;
          height: 5px;
          margin: 0 auto;
          border-radius: 10px;
          margin-bottom: 20px;
        }
        .txt-1{
          font-size: 20px;
          margin-bottom: 10px;
          text-align: center;
        }
        .txt-1-1{
          color: white;
        }
        .base-son-title-txt1{
          display: flex;
          justify-content: center;
          margin: 0 auto;
          line-height: 30px;
          .txt-2,.txt-3{
            font-size: 25px;
            padding: 0 10px;
          }
          .txt-2 {
            color: #FBCC0A;
          }
          img{
            width: 30px;
          }
        }
      }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseSonTitle.vue